<template>
  <div
    v-if="
      dataPermission.includes('CNPS_DEVICE_INVENTORY_UPDATE') ||
      dataPermission.includes('CNPS_DEVICE_INVENTORY_UPDATE_BANK_INVENTORY')
    "
  >
    <div class="breadcrumb-area pos-relative w-100">
      <h1>Sửa kho</h1>
      <div class="btn-group float-right">
        <button
          type="button"
          v-if="dataAdd.level !== 'EMPLOYEE'"
          class="btn font-medium btn-outline-secondary"
          @click="updateWarehouse"
        >
          <i class="bx bx-save"></i> Lưu
        </button>

        <button
          type="button"
          class="btn font-medium btn-outline-secondary"
          @click="checkCloseAdd()"
        >
          <i class="bx bx-exit"></i> Hủy bỏ
        </button>
      </div>
    </div>
    <div v-if="loading" class="card-body p-10 b-t-1-869fb229 text-center">
      <i class="bx bx-loader-circle bx-spin bx-rotate-90 h1"></i>
    </div>

    <div v-else class="card p-10 pt-15 b-t-1-869fb229">
      <ValidationObserver ref="updateWarehouse" class="card-body px-20 mt-2 row">
        <form class="col-md-6">
          <ValidationProvider rules="required" vid="type" name="Loại kho">
            <div class="form-group row" slot-scope="{ errors }">
              <label for class="col-sm-3 col-form-label"
                >Loại kho <span style="color: red">*</span></label
              >
              <div class="col-sm-7">
                <Select2
                  v-model="dataAdd.type"
                  :options="dataType"
                  :disabled="dataAdd.type === 'BANK'"
                />
                <p class="text-danger">{{ errors[0] }}</p>
              </div>
            </div>
          </ValidationProvider>

          <ValidationProvider rules="required" vid="level" name="Cấp kho">
            <div class="form-group row" slot-scope="{ errors }">
              <label for class="col-sm-3 col-form-label"
                >Cấp kho <span style="color: red">*</span></label
              >
              <div class="col-sm-7">
                <Select2
                  v-model="dataAdd.level"
                  :options="dataLevel"
                  @change="queryLevel($event)"
                  :disabled="dataAdd.type === 'BANK'"
                />
                <p class="text-danger">{{ errors[0] }}</p>
              </div>
            </div>
          </ValidationProvider>

          <ValidationProvider
            v-if="dataAdd.level && dataAdd.level != 'ALL'"
            rules="required"
            vid="regions"
            name="Vùng"
          >
            <div class="form-group row" slot-scope="{ errors }">
              <label for class="col-sm-3 col-form-label"
                >Vùng <span style="color: red">*</span></label
              >
              <div class="col-sm-7">
                <Select2
                  v-model="dataAdd.regions"
                  :options="dataConfigRegion"
                  @change="queryProvince($event)"
                  :disabled="dataAdd.type === 'BANK'"
                />
                <p class="text-danger">{{ errors[0] }}</p>
              </div>
            </div>
          </ValidationProvider>

          <ValidationProvider
            v-if="dataAdd.level && dataAdd.level == 'CITY'"
            rules="required"
            vid="cityCode"
            name="Tỉnh/Thành phố"
          >
            <div class="form-group row" slot-scope="{ errors }">
              <label for class="col-sm-3 col-form-label"
                >Tỉnh/Thành phố <span style="color: red">*</span></label
              >
              <div class="col-sm-7">
                <Select2
                  v-model="dataAdd.cityCode"
                  :options="dataProvince"
                  @select="getName($event)"
                  :disabled="dataAdd.type === 'BANK'"
                />
                <p class="text-danger">{{ errors[0] }}</p>
              </div>
            </div>
          </ValidationProvider>

          <ValidationProvider rules="required|minMaxName_2" vid="name" name="Tên kho">
            <div class="form-group row" slot-scope="{ errors }">
              <label class="col-sm-3 col-form-label"
                >Tên kho <span style="color: red">*</span></label
              >
              <div class="col-sm-7">
                <input
                  v-model.trim="dataAdd.name"
                  type="text"
                  class="form-control"
                  :disabled="dataAdd.type === 'BANK'"
                />
                <p class="text-danger">{{ errors[0] }}</p>
              </div>
            </div>
          </ValidationProvider>

          <ValidationProvider rules="required|minMaxName_5" vid="code" name="Mã kho">
            <div class="form-group row" slot-scope="{ errors }">
              <label class="col-sm-3 col-form-label"
                >Mã kho <span style="color: red">*</span></label
              >
              <div class="col-sm-7">
                <input
                  v-model.trim="dataAdd.code"
                  :placeholder="holderCode"
                  type="text"
                  class="form-control"
                  :disabled="dataAdd.type === 'BANK'"
                />
                <p class="text-danger">{{ errors[0] }}</p>
              </div>
            </div>
          </ValidationProvider>

          <ValidationProvider rules="required" vid="address" name="Địa chỉ">
            <div class="form-group row" slot-scope="{ errors }">
              <label for class="col-sm-3 col-form-label"
                >Địa chỉ <span style="color: red">*</span></label
              >
              <div class="col-sm-7">
                <input
                  v-model.trim="dataAdd.address"
                  type="text"
                  class="form-control"
                  :disabled="dataAdd.type === 'BANK'"
                />
                <p class="text-danger">{{ errors[0] }}</p>
              </div>
            </div>
          </ValidationProvider>

          <ValidationProvider rules="required" vid="managerId" name="Quản lý kho">
            <div class="form-group row" slot-scope="{ errors }">
              <label for class="col-sm-3 col-form-label"
                >Quản lý kho <span style="color: red">*</span></label
              >
              <div class="col-sm-7">
                <Select2
                  v-model="dataAdd.managerId"
                  :options="dataManager"
                  :disabled="dataAdd.type === 'BANK'"
                />
                <p class="text-danger">{{ errors[0] }}</p>
              </div>
            </div>
          </ValidationProvider>

          <ValidationProvider rules="required" vid="keeperId" name="Thủ kho">
            <div class="form-group row" slot-scope="{ errors }">
              <label for class="col-sm-3 col-form-label"
                >Thủ kho <span style="color: red">*</span></label
              >
              <div class="col-sm-7">
                <Select2 v-model="dataAdd.keeperId" :options="dataKeeper" />
                <p class="text-danger">{{ errors[0] }}</p>
              </div>
            </div>
          </ValidationProvider>

          <div style="height: 60vh"></div>
        </form>
      </ValidationObserver>
    </div>

    <div v-if="showModalNoti">
      <transition name="modal">
        <div class="modal-mask">
          <div class="modal-wrapper">
            <div class="modal-dialog">
              <div class="modal-content">
                <div class="modal-header">
                  <h5 class="modal-title" id="exampleModalLabel">Thông báo</h5>
                  <button
                    type="button"
                    class="close"
                    data-dismiss="modal"
                    @click="showModalNoti = false"
                    aria-label="Close"
                  >
                    <span aria-hidden="true">&times;</span>
                  </button>
                </div>
                <div class="modal-body text-center">
                  <img :src="srcImage" alt="icon-successs" />
                  <h2 class="f18 py-3">{{ messNoti }}</h2>
                </div>
                <div class="modal-footer">
                  <button
                    type="button"
                    class="btn btn-primary"
                    @click="checkToActionModal(keyCheck)"
                    data-dismiss="modal"
                    v-if="keyCheck === 'accept' || keyCheck === 'back'"
                  >
                    Đồng ý
                  </button>
                  <button
                    type="button"
                    class="btn btn-light"
                    @click="showModalNoti = false"
                    data-dismiss="modal"
                    v-if="keyCheck === 'cancel' || keyCheck === 'back'"
                  >
                    Bỏ qua
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </transition>
    </div>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex'
  import { DeviceService } from '@/services/device.service'
  import { StaffService } from '@/services/staff.service'
  import Config from '@/thirdParty/config'

  export default {
    data() {
      return {
        dataAdd: {},
        warehouseId: this.$route.params.warehouseId,
        dataUser: JSON.parse(localStorage.getItem('userData')),
        dataLevel: Config.levelWarehouseCreate,
        dataType: Config.typeWarehouse,
        dataConfigRegion: [],
        dataProvince: [],
        dataDistrict: [],
        dataManager: [],
        dataKeeper: [],
        loading: false,
        messSuccess: '',
        messErr: '',
        showModalNoti: false,
        messNoti: '',
        srcImage: '',
        keyCheck: '',
        loadingProvince: false,
        loadingDistrict: false,
        userEmployee: {},
        holderCode: '',
      }
    },

    async created() {
      this.loading = true
      await this.getRegions()
      await this.fetchData()
    },

    computed: {
      ...mapGetters({
        dataPermission: 'role/dataPermission',
      }),
    },

    watch: {
      'dataAdd.regions': function () {
        this.dataConfigRegion.find(e => {
          if (e.id === this.dataAdd.regions) {
            this.holderCode = `${e.code.toUpperCase()}_X`
          }
        })
      },
      'dataAdd.cityCode': function () {
        this.dataProvince.find(e => {
          if (e.id === this.dataAdd.cityCode) {
            this.holderCode = `${e.id.toUpperCase()}_X`
          }
        })
      },
    },

    methods: {
      async checkCloseAdd() {
        this.keyCheck = 'back'
        this.showErr('Bạn có chắc chắn muốn huỷ bỏ thao tác không ?')
      },

      async closeAdd() {
        this.$router.push('/cat-warehouse')
      },

      async fetchData() {
        try {
          this.loading = true
          const response = await DeviceService.getDetailWarehouse({
            id: this.warehouseId,
          })
          if (response.code === 1000 || response.success) {
            await this.queryProvince(response.data.regions[0], true)
            this.dataAdd = {
              id: response.data.id,
              type: response.data.type == null ? 'INVENTORY' : response.data.type,
              code: response.data.code,
              name: response.data.name,
              level: response.data.level,
              regions: response.data.regions,
              city: response.data.city,
              cityCode: response.data.cityCode,
              address: response.data.address,
              managerId: response.data.manager === null ? '' : response.data.manager.id,
              keeperId: response.data.keeper === null ? '' : response.data.keeper.id,
              channel: response.data.channel || '',
            }
            this.userEmployee = {
              manager: response.data.manager
                ? `${response.data.manager.name} - ${response.data.manager.email}`
                : '',
              keeper: response.data.keeper
                ? `${response.data.keeper.name} - ${response.data.keeper.email}`
                : '',
            }

            if (
              this.dataAdd.level !== 'EMPLOYEE' ||
              this.dataPermission.includes('CNPS_DEVICE_INVENTORY_EMPLOYEE_UPDATE')
            ) {
              await this.fetchManager(response.data.regions)
            }
          }
          this.dataKeeper = this.dataManager

          if (this.dataAdd.type === 'BANK') {
            this.dataManager = [
              {
                id: response.data.manager.id,
                text: response.data.name,
              },
            ]
          }
        } catch (error) {
          this.showErr(error.message)
        } finally {
          this.loading = false
        }
      },

      async queryLevel(e) {
        delete this.dataAdd.regions
        delete this.dataAdd.city
        delete this.dataAdd.cityCode
        if (e !== 'CITY') {
          this.dataAdd.city = null
          this.dataAdd.cityCode = null
        }
        if (e === 'ALL') {
          this.dataAdd.regions = this.dataConfigRegion.map(e => e.id)
        }
        //  else {
        //   if (typeof (this.dataAdd.regions) == 'string') {
        //     this.dataAdd.regions = [this.dataAdd.regions]
        //   }
        // }
        await this.fetchManager(this.dataAdd.regions)
      },

      async getRegions() {
        const data = await StaffService.getListRegions()
        if (data.data.length > 0) {
          data.data.map(e => this.dataConfigRegion.push({ id: e.id, text: e.name, code: e.code }))
        }
      },

      async queryProvince(e, isInit = false) {
        this.dataAdd.regions = [e]
        try {
          const data = await StaffService.getProvinceRegion({ regionId: [e] })
          if (data.data.length > 0) {
            this.dataProvince = data.data.map(e => {
              return {
                id: e.code,
                text: e.name,
              }
            })
          } else {
            this.dataProvince = []
          }
          if (this.dataAdd.level !== 'ALL' && !isInit) {
            await this.fetchManager([e])
          }
        } catch (error) {
          console.log(error)
        }
      },
      async updateWarehouse() {
        try {
          this.loading = true
          const isSuccess = await this.$refs.updateWarehouse.validate()
          if (!isSuccess) {
            this.keyCheck = 'cancel'
            this.showErr('Vui lòng điền đúng thông tin !')
            return
          }

          // Nếu type là BANK, chỉ gửi id và keeperId
          if (this.dataAdd.type === 'BANK') {
            const bankData = {
              id: this.dataAdd.id,
              keeperId: this.dataAdd.keeperId,
            }

            // Gọi API riêng cho trường hợp BANK
            const response = await DeviceService.updateBankWarehouse(bankData)
            if (response.code === 1000) {
              this.showModalNoti = true
              this.messNoti = 'Cập nhật kho thành công !'
              this.keyCheck = 'accept'
              this.srcImage = require('@/assets/img/noti-success2.svg')
            } else {
              this.keyCheck = 'cancel'
              this.showErr(response.message)
            }
          } else {
            // Xử lý như trước đối với các loại khác
            delete this.dataAdd.created
            delete this.dataAdd.lastModified
            delete this.dataAdd.state

            if (this.dataAdd.level === 'ALL') {
              this.dataAdd.regions = this.dataConfigRegion.map(e => e.id)
            }

            const listIdUser = this.dataManager.map(e => e.id)
            if (listIdUser.indexOf(this.dataAdd.managerId) === -1) {
              delete this.dataAdd.managerId
            }
            if (listIdUser.indexOf(this.dataAdd.keeperId) === -1) {
              delete this.dataAdd.keeperId
            }

            const response = await DeviceService.updateWarehouse(this.dataAdd)
            if (response.code === 1000) {
              this.showModalNoti = true
              this.messNoti = 'Cập nhật kho thành công !'
              this.keyCheck = 'accept'
              this.srcImage = require('@/assets/img/noti-success2.svg')
            } else {
              this.keyCheck = 'cancel'
              this.showErr(response.message)
            }
          }
        } catch (error) {
          this.showErr(error.message)
        } finally {
          this.loading = false
        }
      },

      showErr(message) {
        this.showModalNoti = true
        this.messNoti = message
        this.srcImage = require('@/assets/img/noti-unsuccess2.svg')
      },

      checkToActionModal(keyCheck) {
        if (keyCheck === 'accept' || keyCheck === 'back') {
          this.showModalNoti = false
          this.closeAdd()
        }
      },

      async fetchManager(regionList) {
        try {
          const { data } = await DeviceService.getListUserByRegion({
            regionId: regionList,
          })
          const listManage = data.filter(
            e => e.typeSale !== 'SALE' && e.typeSale !== 'AFTER_SALE' && e.typeSale !== 'TELESALE'
          )
          this.dataManager = listManage.map(e => {
            return {
              id: e.id,
              text: `${e.name} - ${e.userName}`,
            }
          })
          if (
            this.dataAdd.managerId &&
            !this.dataManager.find(e => e.id === this.dataAdd.managerId)
          ) {
            this.dataManager.unshift({
              id: this.dataAdd.managerId,
              text: this.userEmployee.manager,
            })
          }
          this.dataKeeper = data.map(e => {
            return {
              id: e.id,
              text: `${e.name} - ${e.userName}`,
            }
          })
          if (this.dataAdd.keeperId && !this.dataKeeper.find(e => e.id === this.dataAdd.keeperId)) {
            this.dataKeeper.unshift({
              id: this.dataAdd.keeperId,
              text: this.userEmployee.keeper,
            })
          }
        } catch (e) {
          console.error(e)
        }
      },

      getName(item) {
        this.dataAdd.city = item.text
      },
    },
  }
</script>

<style scoped>
  .placeholder {
    background: #f0f0f0;
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    color: #333;
    font-size: 18px;
    font-family: Helvetica;
  }

  .placeholder:hover {
    background: #e0e0e0;
  }
</style>
